import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteObjectiveTemplates } from 'PatientCareCenter/Note/Objective/Templates'
import { PatientCareCenterNoteObjectiveAsterisks } from 'PatientCareCenter/Note/Objective/Asterisks'
import { PatientCareCenterNoteObjectiveObs } from 'PatientCareCenter/Note/Objective/Obs'
import { PatientCareCenterNoteObjectiveNeuro } from 'PatientCareCenter/Note/Objective/Neuro'
import { PatientCareCenterNoteObjectiveBalance } from 'PatientCareCenter/Note/Objective/Balance'
import { PatientCareCenterNoteObjectiveMuskulo } from 'PatientCareCenter/Note/Objective/Musculoskeletal'
import { PatientCareCenterNoteObjectiveMotor } from 'PatientCareCenter/Note/Objective/MotorPlanning'
import { PatientCareCenterNoteObjectiveROM } from 'PatientCareCenter/Note/Objective/ROM'
import { PatientCareCenterNoteObjectiveStr } from 'PatientCareCenter/Note/Objective/Str'
import { PatientCareCenterNoteObjectiveSpecTests } from 'PatientCareCenter/Note/Objective/SpecTests'
import { PatientCareCenterNoteObjectiveOutMeasures } from 'PatientCareCenter/Note/Objective/OutMeasures'
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';


class PatientCareCenterNoteObjective extends React.Component {
    render() {
        return (
            <PatientCareCenterNoteSection id='objective' name='Objective' refProp={this.props.refProp}>
                {this.props.type !== 2 && this.props.type !== 4 && this.props.type !== 6 &&
                    <PatientCareCenterNoteObjectiveTemplates />
                }
                {(!this.props.isPeds && !this.props.isPedsSpeech) &&
                    <PatientCareCenterNoteObjectiveAsterisks />
                }
                <PatientCareCenterNoteObjectiveObs />
                {this.props.isPeds && this.props.isPedsEnabled &&
                    <>
                        <PatientCareCenterNoteObjectiveNeuro />
                        <PatientCareCenterNoteObjectiveMuskulo />
                        <PatientCareCenterNoteObjectiveMotor />
                        <PatientCareCenterNoteObjectiveBalance />
                    </>
                }
                <PatientCareCenterNoteObjectiveROM />
                <PatientCareCenterNoteObjectiveStr />
                <PatientCareCenterNoteObjectiveSpecTests />
                <PatientCareCenterNoteObjectiveOutMeasures outcomesRef={this.props.outcomesRef} />
            </PatientCareCenterNoteSection>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let type = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = type === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPedsSpeech = state.entities.admissions[epno].isPedsSpeech;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds;


    return {
        type,
        isPeds: isPeds,
        isPedsEnabled: isPedsEnabled,
        isPedsSpeech
    };
}

const connectedPatientCareCenterNoteObjective = connect(mapStateToProps)(PatientCareCenterNoteObjective);
export { connectedPatientCareCenterNoteObjective as PatientCareCenterNoteObjective };

